import { render, staticRenderFns } from "./active-peopleNum-list.vue?vue&type=template&id=68ff990b&"
import script from "./active-peopleNum-list.vue?vue&type=script&lang=js&"
export * from "./active-peopleNum-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports